var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("BusinessPurchaseComponentsExcel.title"),
        visible: _vm.dialogVisible,
        width: "600px",
        "before-close": _vm.hide,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-position": "left",
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("BusinessImportHistory.page.templateName"),
                prop: "code",
              },
            },
            [
              _c("BjSelectLov", {
                attrs: { "option-list": _vm.CURRENCY_LIST },
                on: { change: _vm.onChange },
                model: {
                  value: _vm.form.code,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "code", $$v)
                  },
                  expression: "form.code",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("p", [_vm._v(_vm._s(_vm.$t("ExcelConfig.Import")))]),
      _c(
        "div",
        { staticClass: "text" },
        [
          _vm._v(" 1." + _vm._s(_vm.$t("ExcelConfig.ImportExcel")) + " "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: !_vm.form.code },
              on: { click: _vm.onDownload },
            },
            [_vm._v(_vm._s(_vm.$t("ExcelConfig.Download")))]
          ),
          _c("br"),
          _vm._v(" 2." + _vm._s(_vm.$t("ExcelConfig.MustHave"))),
          _c("br"),
          _vm._v(" 3." + _vm._s(_vm.$t("ExcelConfig.MustBe"))),
          _c("br"),
          _vm._v(" 4." + _vm._s(_vm.$t("ExcelConfig.Supports"))),
          _c("br"),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "BjImportFile",
            {
              ref: "BjImportFile",
              attrs: {
                accept: ".csv,.xlsx",
                "limit-size": 128 * 1024,
                "auto-upload": "",
              },
              on: { importFile: _vm.importStart },
              scopedSlots: _vm._u([
                {
                  key: "top",
                  fn: function () {
                    return undefined
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("template", { slot: "default" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("BusinessPurchaseComponentsExcel.uploadSize")
                    ) +
                    " "
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("cancelText")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: !_vm.form.code || !_vm.file },
              on: { click: _vm.confirm },
            },
            [_vm._v(_vm._s(_vm.$t("BusinessPurchaseComponentsExcel.import")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }